<app-header headerText="Candados Fechas De Pago"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true [selectedIndex]="selectedIndex" (selectedTabChange)="tabChanged($event)">

  <mat-tab [disabled]="isEdit">

    <ng-template mat-tab-label>
      <mat-icon>today</mat-icon>
      Nuevas<br>Fechas
    </ng-template>

    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-2">

        <mat-form-field>
          <mat-select placeholder="Tipo de Sueldo:" (selectionChange)="selectedTypeChange($event)" [value]="tempWage">
            <mat-option>Seleccione el Tipo de Sueldo</mat-option>
            <mat-option *ngFor="let wage of wageTypes" [value]="wage">
              {{wage.typeString}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="col-md-4" [ngClass]="{'blocked': !this.savingType}">
        <mat-form-field *ngIf="modPayrollParameter; else emptyTitle">
          <input matInput placeholder="Nombre:" [(ngModel)]="modPayrollParameter.title" type="text" #name="ngModel"
            (keyup)="keyUpMethod($event.target.value)" required>
          <mat-error *ngIf="name.invalid && name?.errors.required">El Nombre es Requerido</mat-error>
        </mat-form-field>
        <ng-template #emptyTitle>
          <mat-form-field>
            <input matInput placeholder="Nombre:" type="text"required>
          </mat-form-field>
        </ng-template>
      </div>

    </div>

    <div [ngClass]="{'blocked': !isNew}">

      <app-payroll [modPayrollParameter]="modPayrollParameter"  [contentLocation]="contentLocation" [wageType]="tempWage" [isEdit]="false"></app-payroll>

      <div class="row my-4">

        <div class="col-md-4 offset-md-4">
          <button class="btn btn-block btn-outline-secondary" (click)="cancelPeriodChanges()">Cancelar</button>
        </div>

        <div class="col-md-4">
          <button class="btn btn-block btn-primary" (click)="savePeriod();">Guardar Cambios</button>
        </div>

      </div>

    </div>

  </mat-tab>

  <mat-tab>

    <ng-template mat-tab-label>
      <mat-icon>edit</mat-icon>
      Editar<br>Fechas
    </ng-template>

    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-4">

        <mat-form-field>
          <mat-select placeholder="Tipo de sueldo:" (selectionChange)="editSelectedTypeChange($event)"
            [value]="editWage">
            <mat-option>Seleccione el tipo de sueldo</mat-option>
            <mat-option *ngFor="let wage of payrollParameters" [value]="wage">
              {{wage.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

    </div>

    <div [ngClass]="{'blocked': !isEdit}">

      <app-payroll [modPayrollParameter]="modPayrollParameter" [contentLocation]="contentLocation"  [wageType]="tempWage" [isEdit]="true"></app-payroll>

      <div class="row my-4">

        <div class="col-md-4 offset-md-4">
          <button class="btn btn-block btn-outline-secondary" (click)="cancelPeriodChanges()">Cancelar</button>
        </div>

        <div class="col-md-4">
          <button class="btn btn-block btn-primary" (click)="savePeriod();">Guardar Cambios</button>
        </div>

      </div>

    </div>

  </mat-tab>

</mat-tab-group>
